
import { computed, defineComponent, ref, type PropType } from 'vue';

export enum DropdownSize {
    Small = 'sm',
    Medium = 'md',
    Large = 'lg'
}

type DropdownSizeValue = DropdownSize | `${DropdownSize}`;

const DEFAULT_MENU_STYLE = {
    left: 'inherit',
    right: '0px'
};

export default defineComponent({
    name: 'AppDropdownMenu',
    props: {
        size: {
            type: String as PropType<DropdownSizeValue>,
            default: DropdownSize.Medium
        }
    },
    setup(props) {
        const dropdownMenuElement = ref<HTMLElement | null>(null);

        const menuClass = computed(() => [
            'dropdown-menu',
            'dropdown-menu-right',
            'show',
            `dropdown-menu-${props.size}`
        ]);

        const fixStyles = computed(() => {
            const element = dropdownMenuElement.value;
            if (!element) return DEFAULT_MENU_STYLE;

            const offsetLeft = element.getBoundingClientRect().left;
            if (offsetLeft < 0) {
                return {
                    left: 'inherit',
                    right: `${offsetLeft - 5}px`
                };
            }

            return DEFAULT_MENU_STYLE;
        });

        return {
            dropdownMenuElement,
            menuClass,
            fixStyles
        };
    }
});
